<!-- TEMPLATE: AppBar.vue -->
<!-- Top application bar — renders drawer toggle, page title, extensions slot, and actions. -->

<script setup lang="ts">
//
// Imports
//
import DrawerToggle from "../molecules/DrawerToggle.vue";
import PageTitle from "../molecules/PageTitle.vue";
import AppBarActions from "../organisms/AppBarActions.vue";
import AppBarExtensions from "../organisms/AppBarExtensions.vue";

//
// Props & Emits
//
withDefaults(
  defineProps<{
    color?: string;
    variant?: "flat" | "tonal" | "outlined" | "text" | "elevated";
    showPageTitle?: boolean;
  }>(),
  {
    color: "primary",
    variant: "flat",
    showPageTitle: true,
  },
);

//
// Composables
//

// Drawer
const { drawer } = useDrawer();

// Page Title
const { pageTitle, breadcrumbs, extensionsConfig } = useAppBar();
</script>

<template>
  <!-- NavBar -->
  <v-app-bar app :color="color" :variant="variant">
    <!-- Prepended Content -->
    <template #prepend>
      <!-- Drawer Toggle -->
      <DrawerToggle v-model="drawer" />

      <!-- Page Title -->
      <PageTitle v-if="showPageTitle" :title="pageTitle" :breadcrumbs="breadcrumbs" />
    </template>

    <!-- Appended Content -->
    <template #append>
      <!-- Actions -->
      <AppBarActions />
    </template>

    <!-- Extensions - Only render slot when needed -->
    <template v-if="extensionsConfig.show" #extension>
      <AppBarExtensions />
    </template>
  </v-app-bar>
</template>

<style>
/* App Bar */
.v-toolbar__content,
.v-toolbar__extension {
  align-items: end !important;
}
</style>
